import { LearnersWorkspacesSchool } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type ShowProps = {
  school: LearnersWorkspacesSchool
}

export const useShowProps = () => useProps<ShowProps>()
